import { useState, useEffect, useCallback } from "react";
import DraggableDualList from "../DraggableDualList/DraggableDualList";
import RoleService from "../../services/RolesService";

function makeItemId(role) {
   return `${role.id}`;
}

function buildTree(allRoles, selectedRoles, includeSelected) {
   const roleMap = new Map();

   for (const role of allRoles) {
      const belongsToRole = selectedRoles.find(
         (ca) => ca.id === role.id
      );

      const shouldInclude = includeSelected ? !!belongsToRole : !belongsToRole;
      if (!shouldInclude) continue;

      const itemId = makeItemId(role);
      roleMap.set(itemId, {
         id: itemId,
         originalId: itemId,
         type: "item",
         label: role.name,
         icon: null,
      });
   }

   return Array.from(roleMap.values());
}
function flattenSelectedItems(rightTree) {
   const selected = [];
   for (const node of rightTree) {
      const items = node.type === "role" ? node.children : [node];
      for (const item of items) {
         if (item.type === "item") {
            selected.push({
               id: item.id,
               value: item.id,
               originalId: item.originalId,
               label: item.label,
            });
         }
      }
   }
   return selected;
}

export function RolesDDL({ onChangeList, roles }) {
   const [allRoles, setAllRoles] = useState([]);
   const [initialLeft, setInitialLeft] = useState([]);
   const [initialRight, setInitialRight] = useState([]);
   const [ready, setReady] = useState(false);

   useEffect(() => {
      (async () => {
         try {
            const response = await RoleService.listRoles();
            if (response && response.data) {
               const data = response.data;
               setAllRoles(data);
            }
         } catch (error) {
            console.error(error);
         }
      })();
   }, []);

   useEffect(() => {
      if (!allRoles.length) return;

      const left = buildTree(allRoles, roles, false);
      const right = buildTree(allRoles, roles, true);

      setInitialLeft(left);
      setInitialRight(right);
      setReady(true);

      if (onChangeList) onChangeList(flattenSelectedItems(left), flattenSelectedItems(right));
   }, [allRoles]);

   const handleChange = useCallback(
      (leftTree, rightTree) => {
         if (onChangeList) onChangeList(flattenSelectedItems(leftTree), flattenSelectedItems(rightTree));
      },
      [onChangeList]
   );

   if (!ready) return null;

   return (
      <DraggableDualList
         labelLeft="Perfis Disponíveis"
         labelRight="Perfis Selecionados"
         initialLeft={initialLeft}
         initialRight={initialRight}
         onChange={handleChange}
      />
   );
}